import React, { useEffect } from "react";
import { cn } from "./cn";
import { applyBunTheme } from "./theme";

/**
 * Bun page scaffold: 60px rail + content column. Spec: every CRM canvas.
 *
 *   <PageShell rail={<IconRail>...</IconRail>}>
 *     <PageHeader title="Pipeline">...</PageHeader>
 *     ...
 *   </PageShell>
 *
 * Default content column is the reading layout (max 1140px, centered,
 * 16px mobile, 32px sm, and 44px xl gutters). `wide` drops the max-width
 * and uses 36px xl gutters for working surfaces that need the full
 * viewport (kanban boards, big tables).
 * The root carries the `bun` base class, so PageShell is what makes a
 * screen a Bun screen.
 */
export default function PageShell({ rail, wide, className, contentClassName, children }) {
  useEffect(() => {
    applyBunTheme();
  }, []);

  return (
    <div className={cn("bun min-h-screen flex items-stretch", className)}>
      {rail}
      <main className="min-w-0 flex-1">
        <div
          className={cn(
            "box-border px-4 pt-7 pb-[72px] sm:px-8",
            wide ? "xl:px-9" : "max-w-[1140px] mx-auto xl:px-11",
            contentClassName
          )}
        >
          {children}
        </div>
      </main>
    </div>
  );
}
